import React, { useEffect, useState, createContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Web3 from "web3";
import ExchangeRateDisplay from "./components/ExchangeRateDisplay";
import BuyCard from "./components/BuyCard";
import PurchaseModal from "./components/PurchaseModal";
import SuccessModal from "./components/SuccessModal";
import CancelModal from "./components/CancelModal";

export const ExchangeRateContext = createContext();

const App = () => {
  const [exchangeRate, setExchangeRate] = useState(null);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [giftMessage, setGiftMessage] = useState(""); // New optional field for gift message
  const [web3, setWeb3] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null); // Track selected amount for purchase
  const [email, setEmail] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);


  const fetchExchangeRate = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_EXCHANGE_RATE_ENDPOINT);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setExchangeRate(data.exchangeRate * 100 / 2);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchExchangeRate();
    const intervalId = setInterval(fetchExchangeRate, 2000);
    return () => clearInterval(intervalId);
  }, []);

  // Initialize Web3 and check for MetaMask
  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
    } else {
      console.error("MetaMask is not installed.");
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setShowSuccessModal(queryParams.get("success") === "true");
    setShowCancelModal(queryParams.get("success") === "false");
  }, []);

  const connectMetaMask = async () => {
    try {
      const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
      setWalletAddress(accounts[0]);
    } catch (error) {
      console.error("Error connecting to MetaMask:", error);
    }
  };

  const handleBuyClick = (amount) => {
    setSelectedAmount(amount);
    setShowModal(true);
  };

  const handleContinue = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_CHECKOUT_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          walletAddress,
          amount: selectedAmount,
          email,
          giftMessage
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const { checkoutUrl } = await response.json(); // Assuming backend responds with `{ checkoutUrl: "URL" }`
      setShowModal(false);
      window.open(checkoutUrl, "_blank");
    } catch (error) {
      console.error("Error creating checkout session:", error);
      alert("There was an error. Please try again.");
    }
  };

  const packageOptions = [10, 20, 50, 100, 200]; // Different purchase amounts

  return (
      <ExchangeRateContext.Provider value={{ exchangeRate, error }}>
        <div className="container mt-5">
          <h1 className="text-center">Buy some 6DO Coins</h1>
          <ExchangeRateDisplay />
          {exchangeRate !== null && (
              <div className="row justify-content-center">
                {packageOptions.map((amount) => (
                    <BuyCard key={amount} amount={amount} onBuyClick={() => handleBuyClick(amount)} />
                ))}
              </div>
          )}

          <PurchaseModal
              show={showModal}
              onHide={() => setShowModal(false)}
              walletAddress={walletAddress}
              onAddressChange={(e) => setWalletAddress(e.target.value)}
              email={email}
              onEmailChange={(e) => setEmail(e.target.value)}
              giftMessage={giftMessage}
              ongiftMessageChange={(e) => setGiftMessage(e.target.value)}
              connectMetaMask={connectMetaMask}
              onContinue={() => handleContinue(process.env[`REACT_APP_STRIPE_LINK_${selectedAmount}`])}
          />
          <SuccessModal show={showSuccessModal} onClose={() => setShowSuccessModal(false)} />
          <CancelModal show={showCancelModal} onClose={() => setShowCancelModal(false)} />
        </div>
      </ExchangeRateContext.Provider>
  );
};

export default App;
